function getBrowserLanguage() {
  return window.navigator.language.split('-')[0].toUpperCase();
}

export {
  getBrowserLanguage
};
